import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';

import { ReportService } from '../../../../../common/services/Report.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { TicketService } from '../../../../../common/services/Ticket.service';
import { TicketTypeService } from '../../../../../common/services/TicketType.service';
import { ServiceService } from '../../../../../common/services/Service.service';
import { PriorityService } from '../../../../../common/services/Priority.service';
import { GroupService } from '../../../../../common/services/Group.service';
import { UserService } from '../../../../../common/services/User.service';
import { ExportService } from '../../../../../common/services/Export.service';
import { ToastrService } from 'ngx-toastr';
import { AgentConst, Filter } from './agent.const';
import { ReportGroupBy } from '../filter/filter.const';
import { TimeWorker } from '../../../../../common/utils/timeWorker';
import * as _ from 'lodash';

declare var $: any;
declare var Chartist: any;

@Component({
  selector: 'report-agent',
  templateUrl: 'agent.template.html',
  styleUrls: ['../report.component.css'],
  providers: [
    ReportService,
    TicketService,
    GroupService,
    UserService,
    TicketTypeService,
    ServiceService,
    PriorityService,
    ExportService,
  ],
})
export class AgentComponent implements OnInit {
  public modelFilter: any = {};
  public data: any;
  public data_page_divide: any;
  totalPage = 0;
  currentPage = 1;
  totalItem = 0;
  public channel: any = 'call';
  public exportData: any = [];
  public agents: any = [];
  public allAgent: any = [];
  public allGroup: any = [];
  public displayColumns: any = [];
  public groupBys = Filter;

  constructor(
    private reportService: ReportService,
    private userService: UserService,
    private exportService: ExportService,
    private groupService: GroupService,
    private toastr: ToastrService
  ) {
    const user = JSON.parse(localStorage.getItem('User'));
    this.modelFilter = {
      from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
      to: moment().format('YYYY-MM-DD HH:mm'),
      source: '-1',
      tenantId: user.tenant_id,
      groups: '',
      queues: '',
      calleds: '',
      campaigns: '',
      agents: '',
      groupBy: `${ReportGroupBy.Agent}`,
    };
    this.displayColumns = AgentConst.displayColumns(this.modelFilter.groupBy);
  }

  async ngOnInit() {
    await this.getAgentList();
    await this.getAllGroup();
    await this.loadChannel(1);
  }

  async changeTime(type) {
    let start: any = moment().format('YYYY-MM-DD HH:mm');

    const end: any = moment().format('YYYY-MM-DD HH:mm');

    switch (type) {
      case 'year': {
        // start = moment().startOf('year').format('YYYY-MM-DD HH:mm');
        start = moment().add('-365', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'month': {
        // start = moment().startOf('month').format('YYYY-MM-DD HH:mm');
        start = moment().add('-30', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'week': {
        // start = moment().startOf('isoWeek').format('YYYY-MM-DD HH:mm');
        start = moment().add('-7', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'day': {
        // start = moment().startOf('day').format('YYYY-MM-DD HH:mm');
        start = moment().add('-1', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'hour': {
        start = moment().add('-1', 'hours').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'minute': {
        start = moment().add('-30', 'minutes').format('YYYY-MM-DD HH:mm');
        break;
      }
      default:
        break;
    }
    this.modelFilter['from'] = start;
    this.modelFilter['to'] = end;
    await this.loadChannel(1);
  }

  async getAgentList() {
    await this.userService.all().subscribe(res => {
      const agentList = [];
      res.data.list.forEach((c: any) => {
        agentList.push({
          text: c.name,
          id: c.agent_id,
          email: c.email,
          phone: c.phone,
          group_id: c.group_id,
        });
      });
      this.allAgent = agentList;
    });
  }
  async getAllGroup() {
    await this.groupService.allGroup({ target: 'user' }).subscribe(res => {
      const list = [];
      res.data.forEach((c: any) => {
        list.push({
          text: c.name,
          id: c.id.toString(),
        });
      });
      this.allGroup = list;
    });
  }

  async loadChannel(research?: any) {
    if (research) {
      this.currentPage = 1;
    }
    const filter = _.assign({}, this.modelFilter);
    if (Array.isArray(filter.groupBy)) {
      filter.groupBy = filter.groupBy.join(',');
    }
    if (Array.isArray(filter.groups)) {
      filter.groups = filter.groups.join(',');
    }
    if (Array.isArray(filter.queues)) {
      filter.queues = filter.queues.join(',');
    }
    if (Array.isArray(filter.calleds)) {
      filter.calleds = filter.calleds.join(',');
    }
    if (Array.isArray(filter.campaigns)) {
      filter.campaigns = filter.campaigns.join(',');
    }
    if (Array.isArray(filter.agents)) {
      filter.agents = filter.agents.join(',');
    }
    if (!filter.groupBy.includes(ReportGroupBy.Agent) && !filter.groupBy.includes(ReportGroupBy.Group)) {
      filter.groupBy = ReportGroupBy.Agent + ',' + filter.groupBy;
    }
    this.reportService.reportAgent(filter).subscribe(res => {
      if (res.data) {
        this.data = res.data;
      } else {
        this.data = [
          {
            source: 0,
            totalCalls: 0,
            totalMissCalls: 0,
            totalAnswerCalls: 0,
            avgSpeedAnswer: 0,
            avgAcdTime: 0,
            avgDuration: 0,
            avgHoldTime: 0,
            totalAcdTime: 0,
            totalDuration: 0,
            missRatio: 0,
          },
        ];
      }
      this.data.map(res => {
        res.display_name = AgentConst.displayNameColumn(res, this.allAgent);
        res.groupName = AgentConst.displayGroup(res, this.allGroup);
        res.missRatio = AgentConst.displayMissRatioColumn(res.missRatio);
        res.slaRatio = AgentConst.displayMissRatioColumn(res.slaRatio);
        res.slaRatio20 = AgentConst.displayMissRatioColumn(res.slaRatio20);
        res.avgSpeedAnswer = TimeWorker.formatSecondToHour(res.avgSpeedAnswer);
        res.avgAcdTime = TimeWorker.formatSecondToHour(res.avgAcdTime);
        res.avgDuration = TimeWorker.formatSecondToHour(res.avgDuration);
        res.avgHoldTime = TimeWorker.formatSecondToHour(res.avgHoldTime);
        res.avgWaitingTime = TimeWorker.formatSecondToHour(res.avgWaitingTime);
        res.avgMissDuration = TimeWorker.formatSecondToHour(res.avgMissDuration);
        res.longestAcdTime = TimeWorker.formatSecondToHour(res.longestAcdTime);
        return res;
      });
      this.totalItem = this.data.length;
      this.totalPage =
        this.data.length % 10 != 0 ? Math.floor(this.data.length / 10) + 1 : Math.floor(this.data.length / 10);
      const begin = (this.currentPage - 1) * 10;
      const end = this.currentPage * 10;
      this.data_page_divide = this.data.slice(begin, end);
    });
  }

  async submitFilter(item?: any) {
    if (item) {
      this.modelFilter = item;
    }
    if (this.modelFilter.from) {
      this.modelFilter.from = moment(this.modelFilter.from).format('YYYY-MM-DD HH:mm');
    }
    if (this.modelFilter.to) {
      this.modelFilter.to = moment(this.modelFilter.to).format('YYYY-MM-DD HH:mm');
    }
    this.displayColumns = AgentConst.displayColumns(this.modelFilter.groupBy);
    await this.loadChannel(1);
  }

  export() {
    this.exportData = [];
    this.data.forEach(data => {
      const dataExport = {};
      this.displayColumns.forEach(d => {
        dataExport[d.title] = data[d.key];
      });
      this.exportData.push(dataExport);
    });
    this.exportService.exportExcel(
      this.exportData,
      'Báo cáo chuyên viên ' + moment(new Date()).format('YYYY-MM-DD HH-mm')
    );
  }

  async setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        await this.loadChannel();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          await this.loadChannel();
        }
      }
    }
  }
  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/report/agents/agent.component.ts